import React from 'react';
import Seo from '../components/seo';
import BlockContent from '@sanity/block-content-to-react';
import richText from '../serializers/richText';
import ProductList from '../components/ProductList';
import Link from '../components/Link';
import { uniqBy } from 'lodash';
// import classNames from 'classnames';

const FeaturedDesigner = ({ pageContext, location }) => {
  const { designer } = pageContext;

  const {
    title,
    url,
    description,
    links = [],
    image,
    products = [],
    seo = {
      metaTitle: '',
      openGraphTitle: '',
      twitterTitle: '',
    },
  } = designer;

  const metaTitle = (seo && seo.metaTitle) || `${title} | Eugenie Detroit`;
  const openGraphTitle =
    (seo && seo.openGraphTitle) || `${title} | Eugenie Detroit`;
  const openGraphImage = seo?.openGraphImage || image;
  const twitterTitle =
    (seo && seo.twitterTitle) || `${title} | Eugenie Detroit`;
  const twitterImage = seo?.twitterImage || image;

  const uniqueProducts = uniqBy(products, 'slug');

  console.log(products);
  console.log(uniqueProducts);

  return (
    <React.Fragment>
      <Seo
        metaTitle={metaTitle}
        metaDescription={seo?.metaDescription}
        metaKeywords={seo?.metaKeywords}
        openGraphTitle={openGraphTitle}
        openGraphDescription={seo?.openGraphDescription}
        openGraphImage={openGraphImage}
        twitterTitle={twitterTitle}
        twitterDescription={seo?.twitterDescription}
        twitterImage={twitterImage}
        pathname={location.pathname}
      />

      <section className="collection-hero bb--dark-brown df fdc fdr--md ">
        <aside className="collection-hero__title p2 pt5--md  pr5--lg br--dark-brown--lg">
          <div className="title df mb2 aib">
            <p className="mono--sm mono--md--md mr1 uppercase spotlight-index__label">
              Designer
            </p>
            <h1 className="serif--sm serif--lg--lg">{title}</h1>
          </div>
          {url && (
            <div className="desc df mb2 aib">
              <p className="mono--sm mono--md--md mr1 uppercase spotlight-index__label">
                URL
              </p>
              <div className="sans--sm  rich-text">
                <a
                  href={url}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="link--underline"
                >
                  {url}
                </a>
              </div>
            </div>
          )}
          {description && (
            <div className="desc df mb2 aib">
              <p className="mono--sm mono--md--md mr1 uppercase spotlight-index__label">
                Description
              </p>
              <div className="sans--sm  rich-text">
                <BlockContent blocks={description} serializers={richText} />
              </div>
            </div>
          )}
          {links && links.length > 0 && (
            <React.Fragment>
              {links.map(link => {
                return (
                  <div key={link._key} className="desc df mb2 aib">
                    <p className="mono--sm mono--md--md mr1 uppercase spotlight-index__label">
                      {link.type}
                    </p>
                    <div className="sans--sm  link--underline">
                      <Link {...link} />
                    </div>
                  </div>
                );
              })}
            </React.Fragment>
          )}
        </aside>
        {image && (
          <section className=" collection-hero__img">
            <div className="x db image spotlight-index__thumbnail-wrapper">
              <picture className="">
                <source
                  srcSet={`${image.url}?w=1600&auto=format&q=100`}
                  media="(min-width: 1000px)"
                />
                <source
                  srcSet={`${image.url}?w=1000&auto=format`}
                  media="(min-width: 600px)"
                />
                <img
                  alt={title}
                  className="x"
                  src={`${image.url}?w=600&auto=format`}
                />
              </picture>
            </div>
          </section>
        )}
      </section>
      <ProductList products={uniqueProducts} />
    </React.Fragment>
  );
};

export default FeaturedDesigner;